<template>
  <div id="app">
    <feature-flag-app :env="env">
      <okta-login />
    </feature-flag-app>
  </div>
</template>

<script>
import OktaLogin from "./components/OktaLogin.vue";
import { FeatureFlagApp } from "@nuskin/ns-feature-flags-vue";
import config from "./config";

export default {
  name: "App",
  components: {
    OktaLogin,
    FeatureFlagApp,
  },
  data() {
    return {
      env: config.env,
    };
  },
};
</script>

<style lang="scss">
#app {
  font-family: "proxima-nova", "OpenSans", "Pridi", "NotoSans", "NotoSansSC",
    "NotoSansHebrew", "NotoSansJapanese", "Hiragino Kaku Gothic Pro",
    "Yu Gothic Medium", "Yu Gothic", Meiryo, "source-han-sans-japanese",
    "source-han-sans-korean", "source-han-sans-simplified-c", Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
